import { Moment } from 'moment';
import { DossierId } from '@/dossier/models/AbstractDossier';
import WorkshopTeam from '@/general/models/WorkshopTeam';
import Vehicle from '@/vehicle/models/Vehicle';
import DossierStatus from '../constants/DossierStatus';
import PlannerConfirmation from './PlannerConfirmation';

export default class DossierDetails {
  id: DossierId | null = null;
  status: DossierStatus | null = null;
  outletDescription = '';
  workshopTeam: Partial<WorkshopTeam> | null = null;
  externalReference = '';
  object: Vehicle | null = null;
  keyLabel = '';
  cleaningStatus: number | null = null;
  waitsOnPremise = false;
  preferredPickUp: Moment | null = null;
  checkedInAt: Moment | null = null;
  dropOff = '';
  appointment: Moment | null = null;
  jobDescriptions: Array<string> = [];
  mobilitySolutionDescription = '';
  mobilitySolutionReference = '';
  contact = '';
  confirmations: Array<PlannerConfirmation> = [];
  duration = '';
}
